import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'
import WTypography from '../../../../../Components/whiteTypography'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const useStyles = styled({
  root: {
    background: '#001b42',
  },
  years: {
    display: 'flex',
    flexDirection: 'column',
  },
  font: {
    fontSize: '1em !important',
  },
})
function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

const customButtonStyle = (query, slug, value) => {
  return {
    backgroundColor: query.get(slug) === value ? 'white' : 'transparent',
    color: query.get(slug) === value ? 'black' : 'white',
    '&:hover': {
      backgroundColor: 'white',
      color: 'black',
    },
  }
}

function Filters({ donutApi, accountTypes, revoApi, operationApi }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const classes = useStyles()
  const [year, setYear] = useState(null)
  const [month, setMonth] = useState(null)
  const [account, setAccount] = useState(null)

  useEffect(() => {
    if (query.get('year')) {
      setYear(query.get('year'))
    }
    if (query.get('month')) {
      setMonth(query.get('month'))
    }
    if (query.get('account_type')) {
      let decodedAccountType = decodeURIComponent(query.get('account_type'))
      setAccount(decodedAccountType)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  let query = useQuery()

  const handleChange = (yearOrMonth, value) => {
    if (yearOrMonth === 'year') {
      setYear(value)
      navigate(`?year=${value}`)
    } else if (yearOrMonth === 'month') {
      setMonth(value)
      query.get('year') ? navigate(`?year=${year}&month=${value}`) : navigate(`?month=${value}`)
    } else {
      setAccount(value)
      query.get('year')
        ? navigate(`?year=${year}&month=${month}&account_type=${value}`)
        : navigate(`?account_type=${value}`)
    }
  }

  const handleSubmit = (e) => {
    let params = ''
    if (account) {
      params = `${params}account_type=${account}&`
    }
    if (year) {
      params = `${params}year=${year}&`
    }
    if (month) {
      params = `${params}month=${month}&`
    }
    donutApi(params)
    revoApi(params)
    operationApi(params)
  }
  return (
    <Box className={`p-2 ${classes.root} rounded`}>
      <WTypography variant="h5">
        {' '}
        <b>{t('dashboardDetail.filter')}</b>{' '}
      </WTypography>

      {/* year */}
      <WTypography className="mt-2">
        {' '}
        <b>{t('dashboardDetail.year')}</b>{' '}
      </WTypography>
      <Box display={'flex'} justifyContent="center">
        <Box className={classes.years}>
          <CustomButton
            sx={customButtonStyle(query, 'year', '2019')}
            className={classes.font}
            onClick={() => handleChange('year', '2019')}
          >
            2019
          </CustomButton>
          <CustomButton
            className={classes.font}
            sx={customButtonStyle(query, 'year', '2020')}
            onClick={() => handleChange('year', '2020')}
          >
            2020
          </CustomButton>
          <CustomButton
            className={classes.font}
            sx={customButtonStyle(query, 'year', '2021')}
            onClick={() => handleChange('year', '2021')}
          >
            2021
          </CustomButton>
        </Box>
        <Box className={classes.years}>
          <CustomButton
            className={classes.font}
            sx={customButtonStyle(query, 'year', '2022')}
            onClick={() => handleChange('year', '2022')}
          >
            2022
          </CustomButton>
          <CustomButton
            className={classes.font}
            onClick={() => handleChange('year', '2023')}
            sx={customButtonStyle(query, 'year', '2023')}
          >
            2023
          </CustomButton>
          <CustomButton
            className={classes.font}
            sx={customButtonStyle(query, 'year', '2024')}
            onClick={() => handleChange('year', '2024')}
          >
            2024
          </CustomButton>
        </Box>
      </Box>

      {/* Months */}
      <WTypography className="mt-2">
        {' '}
        <b>{t('dashboardDetail.month')}</b>{' '}
      </WTypography>
      <Box display={'flex'} justifyContent="center">
        <Box className={classes.years}>
          <CustomButton
            className={classes.font}
            sx={customButtonStyle(query, 'month', '1')}
            onClick={() => handleChange('month', '1')}
          >
            {t('dashboardDetail.jan')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '3')}
            onClick={() => handleChange('month', '3')}
            className={classes.font}
          >
            {t('dashboardDetail.mar')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '5')}
            onClick={() => handleChange('month', '5')}
            className={classes.font}
          >
            {t('dashboardDetail.may')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '7')}
            onClick={() => handleChange('month', '7')}
            className={classes.font}
          >
            {t('dashboardDetail.jul')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '9')}
            onClick={() => handleChange('month', '9')}
            className={classes.font}
          >
            {t('dashboardDetail.sep')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '11')}
            onClick={() => handleChange('month', '11')}
            className={classes.font}
          >
            {t('dashboardDetail.nov')}
          </CustomButton>
        </Box>
        <Box className={classes.years}>
          <CustomButton
            sx={customButtonStyle(query, 'month', '2')}
            onClick={() => handleChange('month', '2')}
            className={classes.font}
          >
            {t('dashboardDetail.feb')}{' '}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '4')}
            onClick={() => handleChange('month', '4')}
            className={classes.font}
          >
            {t('dashboardDetail.apr')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '6')}
            onClick={() => handleChange('month', '6')}
            className={classes.font}
          >
            {t('dashboardDetail.jun')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '8')}
            onClick={() => handleChange('month', '8')}
            className={classes.font}
          >
            {t('dashboardDetail.aug')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '10')}
            onClick={() => handleChange('month', '10')}
            className={classes.font}
          >
            {t('dashboardDetail.oct')}
          </CustomButton>
          <CustomButton
            sx={customButtonStyle(query, 'month', '12')}
            onClick={() => handleChange('month', '12')}
            className={classes.font}
          >
            {t('dashboardDetail.dec')}
          </CustomButton>
        </Box>
      </Box>

      {/* days */}
      <WTypography className="mt-2">
        {' '}
        <b>{t('dashboardDetail.days')}</b>{' '}
      </WTypography>
      <Box display={'flex'} justifyContent="center">
        <Box className={classes.years}>
          <CustomButton className={classes.font}>{t('dashboardDetail.monday')}</CustomButton>
          <CustomButton className={classes.font}>{t('dashboardDetail.wednesday')}</CustomButton>
          <CustomButton className={classes.font}>{t('dashboardDetail.friday')}</CustomButton>
          <CustomButton className={classes.font}>{t('dashboardDetail.sunday')}</CustomButton>
        </Box>
        <Box className={classes.years}>
          <CustomButton className={classes.font}>{t('dashboardDetail.tuesday')} </CustomButton>
          <CustomButton className={classes.font}>{t('dashboardDetail.thursday')}</CustomButton>
          <CustomButton className={classes.font}>{t('dashboardDetail.saturday')}</CustomButton>
        </Box>
      </Box>

      {/* Account types */}
      <WTypography className="mt-2">
        {' '}
        <b>{t('dashboardDetail.accountFilter')}</b>{' '}
      </WTypography>
      <Box className={classes.years}>
        {accountTypes &&
          accountTypes.AccountTypes &&
          accountTypes.AccountTypes.map((v, i) => (
            <CustomButton
              key={i}
              sx={customButtonStyle(query, 'account_type', v.TypeCompte)}
              onClick={() => handleChange('account', v.TypeCompte)}
              className={classes.font}
            >
              {v.TypeCompte}{' '}
            </CustomButton>
          ))}
      </Box>

      <Box display="flex" justifyContent={'center'}>
        <CustomButton onClick={handleSubmit} className={classes.font}>
          {t('dashboardDetail.apply')}
        </CustomButton>
        <CustomButton
          onClick={() => {
            navigate('')
            donutApi('')
            revoApi('')
            operationApi('')
          }}
          className={classes.font}
        >
          {t('dashboardDetail.removeFilters')}
        </CustomButton>
      </Box>
    </Box>
  )
}

export default Filters
